import React from 'react';
import './BusinessGallery.css'; // Asegúrate de crear y ajustar el CSS

const BusinessGallery = () => {
  return (
    <div className="business-gallery">
      <h2>Conoce nuestros negocios</h2>
      <p className="location">📍 Chacabuco y Lavalle</p> {/* Ubicación de la primera galería */}
      <div className="image-gallery">
        <img src="/img/negocio1.jpeg" alt="Negocio 1" />
        <img src="/img/negocio2.jpeg" alt="Negocio 2" />
        <img src="/img/negocio3.jpeg" alt="Negocio 3" />
    </div>
    <p className="location">📍 9 de Julio y Saavedra</p> {/* Ubicación de la primera galería */}
    <div className="image-gallery">
        <img src="/img/negocio4.jpeg" alt="Negocio 4" />
        <img src="/img/negocio5.jpeg" alt="Negocio 5" />
        <img src="/img/negocio6.jpeg" alt="Negocio 6" />
      </div>
    </div>
  );
};

export default BusinessGallery;
